<template>
	<div class="app layout layout--app color color--fontBlack background background--middleGrey minHeight minHeight--100">

		<Sidebar class="app__sidebar"></Sidebar>

		<main class="app__body">
			<transition
				name="fade"
				mode="out-in"
				:duration="{ leave: 0, enter: 0 }"
				appear>
				<router-view class="app__bodyInner" />
			</transition>

			<div class="app__loadingSpinner"></div>
		</main>

		<MhModal
			class="modalWindow--help"
			:show="showImprintModal"
			@close="showImprintModal = false">
			<template slot="header">
				<span class="font font--sizeBig">Impressum</span>
				<a class="font font--sizeBig" @click="showImprintModal = false">×</a>
			</template>
			<template slot="body">
				<strong>Anbieter</strong><br />
				<br />
				Landesamt für Denkmalpflege<br />
				Berliner Straße 12<br />
				73728 Esslingen (Neckar)<br />
				Mail: <a href="mailto:grabungsarchiv@rps.bwl.de">grabungsarchiv@rps.bwl.de</a> <br />
				<br />
				Beachten Sie bitte, dass Ihre Mitteilung an uns über eine E-Mail nicht verschlüsselt wird. Ohne Verschlüsselung ist die Kenntnisnahme durch Dritte nicht ausgeschlossen. Soweit wir Ihrer Mitteilung entnehmen können, dass Sie eine Antwort wünschen, gehen wir davon aus, dass Sie mit einer Beantwortung durch eine unverschlüsselte E-Mail einverstanden sind, wenn unsere Antwort auch nach ihrem Inhalt keiner Verschlüsselung bedarf.<br />
				<br />

				<strong>Hinweise zur Nutzung:</strong><br />
				<br />
				<ol>
					<li>
						Das Nutzungsrecht wird Ihnen unentgeltlich eingeräumt.
					</li>
					<li>
						Das Landesamt für Denkmalpflege Baden-Württemberg im Regierungspräsidium Stuttgart übernimmt
						keine Haftung für Hard- oder Softwareschäden, die durch die Anwendung dieser Anwendung verursacht werden.
					</li>
					<li>Es wird keinerlei Support für die Software gewährleistet. Das LAD und CSGIS haften nicht für Fahrlässigkeit.
						Eine Haftung für mittelbare Schäden oder die Wiederbeschaffung von Daten wird ausgeschlossen.
					</li>
				</ol>
				<br />

				<strong>Projektteam</strong><br />
				<br />
				David Bibby<br />
				Mario Helbing<br />
				Toni Schönbuchner<br />
				<br />
				<strong>Projektumsetzung</strong><br />
				<br />
				CSGIS GbR<br />
				Am Eichbüchl 7<br />
				D - 82223 Eichenau<br />
				<a href="https://www.csgis.de/">www.csgis.de</a><br />
			</template>
			<template slot="footer"></template>
		</MhModal>

		<MhDevInfos
			:showOnHosts="['localhost', 'wp-kickstart-vue:8080']"
		></MhDevInfos>

		<!--
		<MhFormTests></MhFormTests>
		-->

	</div>
</template>

<script>
	// @ is an alias to /src

	//import BaseSelect from '@/components/MhForm/BaseSelect.vue'
	import MhDevInfos from '@/components/MhDevInfos/MhDevInfos.vue'
	import Sidebar from '@/components/Sidebar.vue'
	import MhModal from '@/components/MhModal/MhModal.vue'
	import MhFormTests from '@/components/MhForm/v1/MhFormTests.vue'

	// um das webworker feature zum laufen zu bekommen:
	// muss diese var gesetzt sein UND papaparse.js
	// muss sich im public-ordner befinden damit es per
	// url aufgerufen werden kann
	// taken and modified from https://github.com/mholt/PapaParse/issues/655
	/* eslint-disable */
	//import papa from '@/assets/papaparse.js'
	//import papa from './papaparse.js'
	//papa.SCRIPT_PATH = "./papaparse.js";
	/* eslint-enable */

	//import { rules } from '@/validatorConfig/scripts/rules.js'
	//import generateAndDownloadPDF from '@/validatorConfig/scripts/printReport'
	//import allSchemes from '@/validatorConfig/scripts/schemeRegister-all' // TODO: remove this later
	//import allSchemes from '@/config/registerSchemes.js'
	//import Doc from '@/classes/Doc.class.js'
	//import currentScheme from '@/config/schemes/fotometadaten.scheme.js'

	import Doc from '@/classes/Doc.class.js'
	import docConfig from '@/config/doc.config.js'

	export default {
		name: 'App',
		components: {
			MhDevInfos,
			Sidebar,
			MhModal,
			MhFormTests,
		},
		data() {
			return {
				doc              : null,
				//isParsing        : false,
				choosenCsvFile   : undefined,
				showImprintModal : false,
				showErrorsOnly   : false,
			}
		},
		watch: {},
		computed: {
			currentHost(){
				return location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: '')
			},
			isDevEnv(){
				const hostname = window.location.hostname
				return hostname.includes('XXXlocalhost')
			},
		},
		methods: {
			XXXdoChangeDocData( key, value, doLog = false ){
				const doc = this.doc

				doc.set('data.'+key, this._.isArray( value ) ? value.join(', ') : value )

				const newValue = doc.get('data.'+key)

				// these keys are part of the final filename
				if( key == 'vnrjahr' )  doc.set('vnrjahr', value)
				if( key == 'vnrlfdnr' ) doc.set('vnrlfdnr', value)

				if( doLog ) {
					console.group('doChangeDocData()')
					console.log('doc.get():', doc.get())
					console.log('key:', key)
					console.log('value:', value)
					console.log('newValue:', newValue)
					console.groupEnd()
				}
			},
			XXXdoDownloadCsv( doLog = false ){ // handles the csv download
				if( doLog ){
					console.group('doDownloadCsv()')
				}

				const doc            = this.doc
				const filename       = doc.getTitle()
				const datasets       = doc.getDatasets()
				const rows           = []

				// generate rows array with cells
				this._.forEach( datasets, (dataset)=>{
					const key = dataset.key
					let value = dataset.value

					if( this._.isFunction( dataset.exportHook ) ){
						value = dataset.exportHook( value )
					}

					const row = [ key, value ]

					rows.push( row )

					if( doLog ) console.log('row:', row)
				})

				/*
				// values die nummer sind sollen nicht in quotes gewrapped werden
				// dafür wird das array wrapWithQuotes verwendet
				// siehe https://www.papaparse.com/docs#json-to-csv
				const wrapWithQuotes = []
				this._.forEach( rows, (row)=>{
					const value = row[1]
					wrapWithQuotes.push( !this._.isString( value ) )
					//wrapWithQuotes.push( false )
				})
				*/

				//if( doLog ) console.log('wrapWithQuotes:', wrapWithQuotes)
				if( doLog ) console.groupEnd()

				// generate csvStr for download
				var csvStr = Papa.unparse({
					data : rows,
				}, {
					quotes: false,
					quoteChar: '"',
					escapeChar: '"',
					delimiter: ";",
					header: false,
					newline: "\r\n",
					skipEmptyLines: true, //other option is 'greedy', meaning skip delimiters, quotes, and whitespace.
					columns: null //or array of strings
				})

				if( doLog ){
					console.log('    rows:', rows)
					console.log('  csvStr:', csvStr)
					console.log('filename:', filename)
					console.groupEnd()
				}

				// start the download via fake link click
				const downloadLinkElm = document.createElement("a")
				const csvFile         = new Blob(["\uFEFF"+csvStr], {type: "text/csv; charset=UTF-8"})

				// File name
				downloadLinkElm.download = filename

				// Create a link to the file
				downloadLinkElm.href = window.URL.createObjectURL(csvFile);

				// Hide download link
				downloadLinkElm.style.display = "none"

				// Add the link to DOM
				document.body.appendChild(downloadLinkElm)

				// Click download link
				downloadLinkElm.click()

				// remove the created link after
				downloadLinkElm.remove()
			},
			onSelectFile( files, doLog = false ){
				const file  = files.item(0)

				if( doLog ){
					console.group('onSelectFile()')
					console.log('files:', files)
					console.log('file:', file)
					console.groupEnd()
				}

				this.choosenCsvFile = file

				this.doParseCsv(()=>{
					this.$router.push({ name : 'EditView' })
				})
			},
			doParseCsv( callback = ()=>{}, url = null, doLog = false ){ // parse the given csv to json
				const doc         = this.doc
				const csvFilename = url ? url.replace(/^.*[\\\/]/, '') : this.choosenCsvFile.name
				const parseTarget = url ? url : this.choosenCsvFile

				this.isParsing = true

				Papa.parse( parseTarget, {
					delimiter      : ";", // auto-detect <<< habe ich so von Tonis Code übernommen
					newline        : "", // auto-detect
					quoteChar      : '"',
					header         : false,
					dynamicTyping  : false,
					preview        : 0,
					encoding       : "UTF-8",
					worker         : true,
					comments       : false,
					step           : undefined,
					download       : true,
					skipEmptyLines : true,
					chunk          : undefined,
					fastMode       : undefined,
					withCredentials: undefined,
					error: function error(_error) {
						setTimeout(()=>{
							this.isParsing = false
						}, 500)

						return alert( _error )
					},
					complete: ( response )=>{
						if( doLog ){
							console.log('doParseCsv() complete', response)
							console.log('doc.get()', doc.get())
						}

						doc.resetData()

						if( doLog ) console.group('walk csv data')

						// walk the parsed rows and set doc data
						response.data.forEach( (row, index) => {
							const key     = row[0]
							const dataset = doc.getDatasets().filter( i => i.key === key )[0]
							let value     = this._.trim( row[1] )

							if( doLog ){
								console.log('key:', key)
								console.log('dataset:', dataset)
								console.log('value:', value)
								console.log('-----')
							}

							if( this._.isFunction( dataset.importHook ) ){
								value = dataset.importHook( value )
							}

							if( doLog ) console.log('importHook(value):', value)

							// diese beiden keys werden im doc-title verwendet,
							// deswegen werden sie hier nochmal seperat gesetzt
							if( key == 'vnrjahr' )  doc.set('vnrjahr', value)
							if( key == 'vnrlfdnr' ) doc.set('vnrlfdnr', value)

							doc.set('data.'+key, value )
						})

						if( doLog ) console.groupEnd()

						callback()
					},
				})
			},
			cleanString( keyStr ){ // cleans column names
				let newStr = keyStr

				newStr = newStr.replace(/^[\s]+/g, '') // RemoveFirstBlank
				newStr = newStr.replace(/[^\x00-\x7F]/g, '') // RemoveNonAscii
				newStr = newStr.replace(/[\t]+/g, '') // RemoveTab

				return newStr
			},
		},
		created(){},
		mounted(){
			this.doc = new Doc( docConfig )
		},
	}
</script>

<style lang="less">
	@import (reference) "less/vars.less";
	@import "less/includes/normalize.include.less";
	@import "less/fonts.less";
	@import (reference) "less/mixins.less";
	@import "less/atoms.less";
	//@import "less/includes/grid.include.less";

	body {
		.font;
		.font--sans;
		.font--sizeDefault;

		max-width: 100vw;
		overflow-y: auto;
		overflow-x: hidden;

		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
	strong, b {
		.font--bold;
	}
	button {
		cursor: pointer;
	}
	h1, h2, h3, h4, h5 {
		font-size: inherit;
		line-height: inherit;
		font-weight: inherit;
		margin: 0;
	}
	a {
		cursor: pointer;
		color: @swatches[blue];
		text-decoration: none;
	}
	pre {
		@color: black;
		@fontSize: 14px;

		position: relative;
		padding: 0.5em;
		width: 100%;
		min-height: 2em;
		max-height: 200px;

		//margin-bottom: 0.5em;
		//margin-bottom: -1px;
		//&:first-of-type { margin-top: 1em; }
		//&:last-of-type { margin-bottom: 1em; }

		//color: fade(@color, 65);
		tab-size: 4;
		white-space: pre;
		font-size: @fontSize;
		line-height: 1.1em;

		outline: 1px solid fade(@color, 25);
		background-color: fade(@color, 5);
		overflow: auto;
		//display: none;

		// label
		&[name]:after {
			position: absolute;
			top: 0; right: 0;
			background-color: fade(@color, 15);
			font-size: @fontSize*0.75;
			line-height: 1em;
			font-family: sans-serif;
			color: fade(@color, 75);
			padding: 0.25em 0.5em;
			content: attr(name);
			font-family: inherit;
		}

		&:first-child {
			margin-top: 0em;
		}
	}
	hr {
		border: none;
		border-top: 1px solid;
		margin: 0.5em 0;
		opacity: 0.25;
	}
	ul, ol {
		margin-left: 1rem;
	}
	select {
		cursor: pointer;
		width: 100%;
	}
	label {
		cursor: pointer;
		user-select: none;
	}

	.layout {
		& {}

		&--app {
			display: grid;
			grid-template-columns: minmax(0, 300px) minmax(0, 1fr);
		}
	}
	.contentModule {
		[showBorders2] & {
			outline: 1px solid fade(red, 80);
			//.outline( red );
			.label( attr(class), fade(red, 80), black );
		}

		[showBorders2] &__inner {
			outline: 1px dotted fade(red, 80);
		}
	}
	.contentModule {
		position: relative;

		&__inner {
			position: relative;
			margin: 0 auto;
		}
	}
	.view {
		padding: 1rem;
		display: flex;
		flex-direction: row;

		& > * > * {
			box-shadow: 0 0 1em 0em fade( black, 10 );
		}
	}
	.richText { // handle links usw.
		a {
			transition: all 0.1s ease;
			color: inherit;
			text-decoration: none;
			border-bottom: 1px solid fade( black, 25 );
		}
		a:hover {
			border-bottom-color: currentColor;
		}

		&.font--colorWhite a {
			border-bottom-color: fade( white, 25 );
		}
		&.font--colorWhite a:hover {
			border-bottom-color: white;
		}
	}
	.blend--multiply {
		//mix-blend-mode: multiply;
		//isolation: isolate;
		//transform: translateZ(1);
	}

	.BaseFileInput,
	.BaseButton {
		--border : 1px solid darken( @swatches[blue], 10 ) !important;
		--activeBackgroundColor : @swatches[blue] !important;
		--hoverBackgroundColor : darken( @swatches[blue], 5 ) !important;
	}

	.BaseButton--downloadBtn {
		--border : 1px solid darken( @swatches[darkGreen], 10 ) !important;
		--activeBackgroundColor : @swatches[darkGreen] !important;
		--hoverBackgroundColor : darken( @swatches[darkGreen], 5 ) !important;
	}
	.BaseTextarea__textarea {
		//resize: none;
	}

	.MhModal {
		&__inner {
			max-height: 90vh;

			min-height: 50vh;
			overflow: hidden;

			border-radius: 0.25em;
			box-shadow: 0 0 1em 0em fade( black, 10 );
		}

		&__header {
			border-bottom: 1px solid @swatches[grey];

			&Inner {
				display: flex;
				justify-content: space-between;
				flex-grow: 1;
				padding: 0.75em;
			}
			span {
				opacity: 0.75;
			}
		}
		&__body {
			overflow: auto; flex-grow: 1;

			&Inner {
				padding: 0.75em;
			}
		}
		&__footer {
			border-top: 1px solid @swatches[grey];
		}

		&.modalWindow--help &__inner {
			min-height: 75vh;
			max-width: 750px;
		}
		&.modalWindow--datasets {}

		.modalWindow__closeBtn {
			padding-right: 0.25em;
		}
	}

	.app {}
	.app__bodyInner {}

	@media @mediaQueries[xs] {}
	@media @mediaQueries[sm] {}
	@media @mediaQueries[md] {}
	@media @mediaQueries[dt] {}
	@media @mediaQueries[lg] {}
	@media @mediaQueries[xl] {}
</style>
